export default {
  'pages.dailyReport.title': '每日报表',
  'pages.dailyReport.subtitle': '管理和查看每日工作报表',
  'pages.dailyReport.create': '新建报表',
  'pages.dailyReport.edit': '编辑报表',
  'pages.dailyReport.batchDelete': '批量删除',
  'pages.dailyReport.confirmDelete': '确定要删除这个报表吗？',
  'pages.dailyReport.confirmBatchDelete': '确定要删除选中的 {count} 个报表吗？',
  'pages.dailyReport.deleteSuccess': '删除报表成功',
  'pages.dailyReport.batchDeleteSuccess': '批量删除报表成功',
  'pages.dailyReport.createSuccess': '创建报表成功',
  'pages.dailyReport.updateSuccess': '更新报表成功',
  'pages.dailyReport.deleteFailed': '删除报表失败',
  'pages.dailyReport.batchDeleteFailed': '批量删除报表失败',
  'pages.dailyReport.submitFailed': '提交报表失败',
  'pages.dailyReport.getListFailed': '获取报表列表失败',
  'pages.dailyReport.columns.reportDate': '报表日期',
  'pages.dailyReport.columns.createdName': '提交人',
  'pages.dailyReport.columns.todayWork': '今日完成工作',
  'pages.dailyReport.columns.tomorrowPlan': '明日计划',
  'pages.dailyReport.columns.problem': '遇到问题',
  'pages.dailyReport.columns.hours': '工时',
  'pages.dailyReport.columns.createTime': '创建时间',
  'pages.dailyReport.columns.operations': '操作',
  'pages.dailyReport.actions.view': '查看',
  'pages.dailyReport.actions.edit': '编辑',
  'pages.dailyReport.actions.delete': '删除',
  'pages.dailyReport.reportDateRequired': '请选择报表日期',
  'pages.dailyReport.todayWorkRequired': '请输入今日完成工作',
  'pages.dailyReport.todayWorkPlaceholder': '请输入今日完成工作内容',
  'pages.dailyReport.tomorrowPlanPlaceholder': '请输入明日计划',
  'pages.dailyReport.problemPlaceholder': '请输入遇到的问题',
  'pages.dailyReport.hoursPlaceholder': '请输入工时（小时）',
  'pages.dailyReport.detail.title': '报表详情',
  'pages.dailyReport.detail.basicInfo': '基本信息',
  'pages.dailyReport.detail.timeInfo': '时间信息',
  'pages.dailyReport.detail.todayWork': '今日完成工作',
  'pages.dailyReport.detail.tomorrowPlan': '明日计划',
  'pages.dailyReport.detail.problem': '遇到问题',
};
